import React, { memo, useEffect, useState } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import config from '../../../../../config';
import Table from '../../../../helpers/AgGridTable';
import AgHeader from '../MidPanel/AgHeader';
import { GridCard } from '../../../../helpers/GridCard';

import style from './style.module.css';

const ApprovedFormat = ({ value }) => {
  const className = value ? 'fa-check' : 'fa-times';

  return (
    value && (
      <div>
        <i className={classNames(style.iconApproved, 'fa', className)} />
      </div>
    )
  );
};

const TargetsComponent = ({ targets, common, canEditData, onDoubleClick, onSort }) => {
  const [api, setApi] = useState(null);

  useEffect(() => {
    if (api) {
      api.sizeColumnsToFit();
    }
  }, [api]);

  const columnDefs = config.tables.getIn(['project', 'targetBuyer', 'columns']).map(column => {
    const field = column.get('field');

    if (field === 'approved') {
      return column.merge({
        headerComponentFramework: AgHeader,
        cellRendererFramework: ApprovedFormat,
        sortable: true,
      });
    }

    return column.merge({
      headerComponentFramework: AgHeader,
      sortable: true,
    });
  });

  const handleRowDoubleClicked = params => {
    if (!canEditData) {
      return;
    }

    onDoubleClick({
      row: Map({
        id: params.data.id,
      }),
      type: 'targets',
    });
  };

  const handleGridSizeChanged = () => {
    if (api) {
      api.sizeColumnsToFit();
    }
  };

  const handleGridReady = params => {
    setApi(params.api);
  };

  const handleSort = sortModel => {
    if (!canEditData) {
      return;
    }

    if (sortModel && sortModel.length) {
      onSort(sortModel, {
        type: 'targets',
        direction: sortModel[0].sort === 'asc' ? 'up' : 'down',
        field: sortModel[0].colId,
      });
    }
  };

  const rowData = targets.map((target, i) => target.set('i', i + 1));

  return (
    <GridCard className={style.host}>
      <Table
        columnDefs={columnDefs}
        isFetching={common.get('targetLoading')}
        onGridReady={handleGridReady}
        onGridSizeChanged={handleGridSizeChanged}
        onRowDoubleClicked={handleRowDoubleClicked}
        onSortModelChanged={handleSort}
        rowData={rowData}
        enableSorting
      />
    </GridCard>
  );
};

TargetsComponent.propTypes = {
  canEditData: PropTypes.bool.isRequired,
};

/** Targets component. */
export const Targets = memo(TargetsComponent);
